module.exports = __webpack_public_path__ + "static/media/web_development.74df851c.jpg";